import { render, staticRenderFns } from "./WelcomeCustomer.vue?vue&type=template&id=30137b18&scoped=true&lang=pug&"
import script from "./WelcomeCustomer.vue?vue&type=script&lang=js&"
export * from "./WelcomeCustomer.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCustomer.vue?vue&type=style&index=0&id=30137b18&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30137b18",
  null
  
)

export default component.exports